import { DownloadUrlSearchParams } from '../../constants';
// The browser properly encodes / decodes the file names (at least in cyrilic)
// No need for additional encoding / decoding
// TODO: Test with other languages that might need encoding.
export const generateDownloadUrl = ({ fsEntryId, fsEntryName, fsEntrySize, isUnifiedDownload, scope, }) => {
    const searchParams = new URLSearchParams({
        [DownloadUrlSearchParams.FsEntryId]: fsEntryId,
        [DownloadUrlSearchParams.FsEntryName]: fsEntryName,
    });
    if (fsEntrySize !== undefined) {
        searchParams.set(DownloadUrlSearchParams.FsEntrySize, fsEntrySize.toString());
    }
    if (isUnifiedDownload) {
        searchParams.set(DownloadUrlSearchParams.IsUnifiedDownload, 'true');
    }
    return `/${scope}?${searchParams.toString()}`;
};
export const parseDownloadUrlString = (urlString) => {
    const url = new URL(urlString);
    const urlParams = url.searchParams;
    const fsEntryId = urlParams.get(DownloadUrlSearchParams.FsEntryId);
    const fsEntryName = urlParams.get(DownloadUrlSearchParams.FsEntryName);
    // `null` for batch downloads - see generateDownloadUrl.
    const fsEntrySize = urlParams.get(DownloadUrlSearchParams.FsEntrySize);
    const isUnifiedDownload = urlParams.has(DownloadUrlSearchParams.IsUnifiedDownload);
    if (!fsEntryId || !fsEntryName) {
        throw new Error(`One or more search parameters not found in the url ${urlString}`);
    }
    return { fsEntryId, fsEntryName, fsEntrySize, isUnifiedDownload };
};
export const initiateDownloadViaAnchorElement = (href) => {
    const a = document.createElement('a');
    a.href = href;
    a.target = '_blank'; // Has to be target="_blank" otherwise SW will not intercept
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};
/**
 * @returns  A function that removes the added iFrame from the DOM
 */
export const initiateDownloadViaIframe = (downloadUrl) => {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none'; // Make it invisible
    document.body.appendChild(iframe);
    // Setting the src triggers the navigation/request, intercepted by SW
    iframe.src = downloadUrl;
    return () => {
        document.body.removeChild(iframe);
    };
};
